<h1 mat-dialog-title>{{'labels.switchTenant' | translate}}</h1>
<div mat-dialog-content>
  <div class="switch-entry" *ngFor="let tenant of tenants">
    <div class="switch-icon">
      <mat-icon *ngIf="tenant.tenantId === tenantId">done</mat-icon>
    </div>
    <div class="switch-label">
      {{tenant.type | translate}} 
      <span *ngIf="!!tenant.name"> ({{tenant.name}})</span>
    </div>
    <div class="switch-button">
      <button mat-flat-button color="primary" (click)="switch(tenant.tenantId)" [disabled]="tenant.tenantId === tenantId">{{ 'buttons.switch' | translate }}</button>
    </div>
  </div>
</div>
<div class="form-actions" mat-dialog-actions>
  <button mat-stroked-button color="primary" [mat-dialog-close]="" cdkFocusInitial>{{ 'buttons.cancel' | translate }}</button>
  <span class="spacer"></span>
</div>